/**
 * @generated SignedSource<<9001a7d6b83492c174a9b9db0d1ea24b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateUserActivitiesInput = {
  activityIds?: ReadonlyArray<any | null | undefined> | null | undefined;
  clientMutationId?: string | null | undefined;
};
export type useUserActivitiesMutation$variables = {
  input: UpdateUserActivitiesInput;
};
export type useUserActivitiesMutation$data = {
  readonly updateUserActivities: {
    readonly query: {
      readonly " $fragmentSpreads": FragmentRefs<"useUserActivities_query">;
    } | null | undefined;
  } | null | undefined;
};
export type useUserActivitiesMutation = {
  response: useUserActivitiesMutation$data;
  variables: useUserActivitiesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUserActivitiesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateUserActivitiesPayload",
        "kind": "LinkedField",
        "name": "updateUserActivities",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useUserActivities_query"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useUserActivitiesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateUserActivitiesPayload",
        "kind": "LinkedField",
        "name": "updateUserActivities",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "orderBy",
                        "value": [
                          "ACTIVITY_BY_ACTIVITY_ID__SEQUENCE_ASC"
                        ]
                      }
                    ],
                    "concreteType": "UserActivityConnection",
                    "kind": "LinkedField",
                    "name": "userActivities",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserActivity",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "activityId",
                            "storageKey": null
                          },
                          (v2/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "userActivities(orderBy:[\"ACTIVITY_BY_ACTIVITY_ID__SEQUENCE_ASC\"])"
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "42b7630e4c7113624d44c59abccfbeb8",
    "id": null,
    "metadata": {},
    "name": "useUserActivitiesMutation",
    "operationKind": "mutation",
    "text": "mutation useUserActivitiesMutation(\n  $input: UpdateUserActivitiesInput!\n) {\n  updateUserActivities(input: $input) {\n    query {\n      ...useUserActivities_query\n      id\n    }\n  }\n}\n\nfragment useUserActivities_query on Query {\n  currentUser {\n    userActivities(orderBy: [ACTIVITY_BY_ACTIVITY_ID__SEQUENCE_ASC]) {\n      nodes {\n        activityId\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5301abeeba75bb55daafeaeae1e18ab1";

export default node;
